<template>
  <div>
    <div
      class="instruction_title text-left para-mrgn-20"
      v-translate:dynamic_string="{
        key: `${translationKeyInitial}_formattedBody`,
        val: lang,
        html: question.formattedBody
      }"
      v-html="question.formattedBody"
    />
    <div @click.once="$emit('onClick', question)">
      <textarea v-model="question.answer" class="input-text readonly form-control" @input="onFieldChange" v-translate:rsb_hint_step_body_text.placeholder="lang" placeholder="Answer" :disabled="isFieldDisabled" :class="{ 'is-danger': hasFieldError }"></textarea>
      <span class="text-danger pl-5 fw-bold pt-10" v-if="hasFieldError">{{ fieldErrorText }}</span>
    </div>
  </div>
</template>

<script>
import langTranslate from "./lang-translate";

export default {
  name: "text-response",
  mixins: [langTranslate],
  data() {
    return {
      hasFieldError: "",
      fieldErrorText: ""
    };
  },
  props: ["lang", "question", "isFieldDisabled", "isLegacyStudy"],
  computed: {
    componentData() {
      return this.question.constraints;
    }
  },
  mounted() {
    this.$root.$on("questionSkipped", (notifyObj) => {
      if(!!notifyObj && notifyObj.identifier === this.question.identifier && notifyObj.skipped){
        this.clearAnswer();
      }
    });
  },
  methods: {
    onFieldChange() {
      this.onAnswerChange();
    },

    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";
    },
    onAnswerChange() {
      this.hasFieldError = false;
      this.$nextTick(() => {
        this.componentData.computedScore = this.componentData.score;
        this.componentData.actualScore = this.componentData.score;
        this.$emit("onAnswerChange", this.question);
      });
    },
    clearAnswer(){
      this.question.answer = "";
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
    }
  }
};
</script>
